module["exports"] = [
  "Apt. ###",
  "Suite ###"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/cz/address/secondary_address.js
// module id = 205
// module chunks = 0